import clsx from "clsx";
import type { PropsWithChildren } from "react";

import { useDrawerContext } from "@/components/Drawer/DrawerContext";

type DrawerFooterProps = PropsWithChildren;

export function DrawerFooter({ children }: DrawerFooterProps) {
  const { backgroundColor } = useDrawerContext();

  return (
    <div
      className={clsx(
        "sticky bottom-0 border-t border-t-stroke-neutral-soft px-main pt-4",
        {
          "bg-white": backgroundColor === "white",
          "bg-surface-background": backgroundColor === "background",
        },
      )}
    >
      {children}
    </div>
  );
}
